import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';

import './index.sass';

const { block, el } = bem('hello-customer')
const HelloCustomer = ({customerName, position = 'right', ...rest}) => {
    return (
        <div className={block(position)}>
            <Icon name={'hand-waving'} />
            <Text>Приветствуем, <b>{customerName}</b></Text>
        </div>
    )
}

export default HelloCustomer;
